import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { isFinishedUploadingSelector } from '@air/redux-uploader';

export const useUploadCancelAlertOnUnload = () => {
  const isFinished = useSelector(isFinishedUploadingSelector);

  useEffect(() => {
    const handleBeforeunload = (event: BeforeUnloadEvent) => {
      if (!isFinished) {
        event.preventDefault();

        event.returnValue = 'Are you sure?\nThis will cancel all assets that have not been uploaded yet.';
      }
    };

    window.addEventListener('beforeunload', handleBeforeunload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeunload);
    };
  }, [isFinished]);
};
